export const buttonsContainer = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem'
}

export const subHeading = { color: 'gray', fontSize: '20px' }
export const subHeadingText = { color: 'gray', fontSize: '16px' }
